import { createGenericFetchAction } from 'ContentData/helpers/reduxHelpers';
import * as graphqlClient from 'ContentData/api/DataQueries';
import { MODULE_FETCH_GRAPHQL_VARIABLES } from 'ContentData/actions/ActionTypes';
const fetchGraphqlVariables = createGenericFetchAction(MODULE_FETCH_GRAPHQL_VARIABLES, graphqlClient.fetchGraphqlVariables);
export function fetchModuleDataVariables(absoluteDataQueryPath) {
  return fetchGraphqlVariables(absoluteDataQueryPath);
}